import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function PencilIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "14"}
      height={height || "14"}
      viewBox="0 0 14 14"
    >
      <path
        id="Caminho_10235"
        data-name="Caminho 10235"
        d="M5.615-10.114a1.31,1.31,0,0,0,0-1.857L3.972-13.614a1.315,1.315,0,0,0-1.857,0L.854-12.353a.328.328,0,0,0,0,.465L3.89-8.853a.328.328,0,0,0,.465,0ZM-.228-11.271-7.409-4.09l-.58,3.322a.657.657,0,0,0,.76.76L-3.906-.59,3.274-7.77a.328.328,0,0,0,0-.465L.239-11.271A.332.332,0,0,0-.228-11.271ZM-4.606-4.705a.381.381,0,0,1,0-.541L-.4-9.458a.381.381,0,0,1,.541,0,.381.381,0,0,1,0,.541L-4.065-4.705A.381.381,0,0,1-4.606-4.705Zm-.987,2.3h1.313v.993L-6.045-1.1l-.85-.85.309-1.764h.993Z"
        transform="translate(7.999 13.998)"
        fill={color || "#fb972e"}
      />
    </svg>
  );
}
